import React from "react";
import MailHome from "../sections/mail/MailHome";
import PageWrapper from "../components/PageWrapper";
import Helmet from "react-helmet"

const IndexPage = () => {
  return (
    <>
      <Helmet>
        <title>Mail Forwarding Australia | Scan, Read & Forward | HotSnail</title>
        <meta name="title" content="Mail Forwarding Australia | Scan, Read & Forward | HotSnail" />
        <meta name="description" content="Mail forwarding in Australia, with a scan first. See every letter online, then forward it worldwide by Australia Post or DHL, store it or shred it." />

        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.hotsnail.com.au/" />
        <meta property="og:title" content="Mail Forwarding Australia | Scan, Read & Forward | HotSnail" />
        <meta property="og:description" content="Mail forwarding in Australia, with a scan first. See every letter online, then forward it worldwide by Australia Post or DHL, store it or shred it." />
        <meta property="og:image" content="https://www.hotsnail.com.au/hotsnail/img/HotSnailLogo2.png"></meta>

        {/* No address here: the Ashmore street address must never be published
            (docs/seo-keywords.md). */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://www.hotsnail.com.au/#organization",
                name: "HotSnail",
                url: "https://www.hotsnail.com.au/",
                logo: "https://www.hotsnail.com.au/hotsnail/img/HotSnailLogo2.png",
                description: "Mail forwarding, mail scanning and parcel forwarding from Australia.",
                areaServed: "Worldwide",
                sameAs: [
                  "https://www.facebook.com/HotSnail",
                  "https://twitter.com/snail_hot",
                ],
              },
              {
                "@type": "WebSite",
                "@id": "https://www.hotsnail.com.au/#website",
                name: "HotSnail",
                url: "https://www.hotsnail.com.au/",
                inLanguage: "en-AU",
                publisher: { "@id": "https://www.hotsnail.com.au/#organization" },
              },
            ],
          })}
        </script>
      </Helmet>

      <PageWrapper footerDark><MailHome /></PageWrapper>
    </>
  );
};
export default IndexPage;
